import { render, staticRenderFns } from "./PrepareShareDocument.vue?vue&type=template&id=3d275513&"
import script from "./PrepareShareDocument.vue?vue&type=script&lang=js&"
export * from "./PrepareShareDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports